import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Constants } from 'src/app/app.constants';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Guide } from '../../../models/index';
import { AuthService, ListService } from '../../../services/index';
import { AssetViewerComponent } from '../asset-viewer/asset-viewer.component';
import { AnalyticsAbstract } from 'src/app/services/analytics/analytics.abstract';

@Component({
  selector: 'assets',
  templateUrl: './assets.component.html',
  styleUrls: ['./assets.component.css'],
})
export class AssetsComponent {
  @Input() smallTitle = false;
  @Input() title = '';
  @Input() subtitle: string = '';
  @ViewChild('myTable') table: any;

  guides: Guide[] = [];
  guidesLoading = false;
  error = false;

  constructor(
    public constants: Constants,
    public authService: AuthService,
    private listService: ListService,
    private dialog: MatDialog,
    private mixpanel: AnalyticsAbstract
  ) {}

  ngOnInit() {
    this.subtitle = this.authService.getNestedUserProperty('merchant', 'name');
    this.getGuides();
  }

  getGuides(): void {
    this.guidesLoading = true;
    this.listService
      .getList('assets')
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.guides = res;
            this.guides?.sort((a, b) => a.order! - b.order!);
          }
        },
        error: (res: HttpErrorResponse) => {
          this.error = true;
          this.constants.snack(res.error.message);
        },
      })
      .add(() =>
        setTimeout(() => {
          this.guidesLoading = false;
        }, 500)
      );
  }

  get loading(): boolean {
    return this.guidesLoading;
  }

  open(guide: Guide): void {
    this.mixpanel.track(Constants.analytics_keys.viewAsset, {
      Asset: guide.title,
    });

    this.dialog.open(AssetViewerComponent, {
      autoFocus: false,
      data: {
        guide: guide,
      },
      width: '95%',
      maxWidth: '1400px',
      height: 'auto',
      maxHeight: '90vh',
      panelClass: ['asset-viewer-dialog', 'responsive-dialog'],
      scrollStrategy: new NoopScrollStrategy(),
      disableClose: true,
    });
  }

  get firstName(): string {
    return this.authService.getUserProperty('firstName');
  }

  getThumbnailUrl(guide: Guide): string {
    const baseUrl = `https://remy-system.s3.eu-west-2.amazonaws.com/assets/${guide.key}`;
    return `${baseUrl}/${guide.key}_sm.${guide.extension}`;
  }
}
